import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { servicesAPI } from '../utils/api';
import './Services.css';

const categories = ['All', 'Plumber', 'Electrician', 'Cleaner', 'Tutor', 'Beautician', 'Carpenter', 'Painter', 'AC Repair'];
const cities = ['All Cities', 'Islamabad', 'Rawalpindi', 'Lahore', 'Karachi', 'Peshawar', 'Multan'];

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    category: searchParams.get('category') || '',
    city: '',
    search: searchParams.get('search') || '',
    minPrice: '',
    maxPrice: '',
  });

  useEffect(() => {
    fetchServices();
  }, [filters]);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.category && filters.category !== 'All') params.category = filters.category;
      if (filters.city && filters.city !== 'All Cities') params.city = filters.city;
      if (filters.search) params.search = filters.search;
      if (filters.minPrice) params.minPrice = filters.minPrice;
      if (filters.maxPrice) params.maxPrice = filters.maxPrice;
      const res = await servicesAPI.getAll(params);
      setServices(res.data);
    } catch (err) {
      setServices([]);
    }
    setLoading(false);
  };

  return (
    <div className="services-page">
      <div className="services-sidebar">
        <h3>Filters</h3>

        <div className="filter-group">
          <label>Search</label>
          <input
            type="text"
            placeholder="Search services..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
        </div>

        <div className="filter-group">
          <label>Category</label>
          <div className="filter-pills">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-pill ${filters.category === cat || (cat === 'All' && !filters.category) ? 'active' : ''}`}
                onClick={() => setFilters({ ...filters, category: cat === 'All' ? '' : cat })}
              >{cat}</button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label>City</label>
          <select value={filters.city} onChange={(e) => setFilters({ ...filters, city: e.target.value })}>
            {cities.map(c => <option key={c} value={c === 'All Cities' ? '' : c}>{c}</option>)}
          </select>
        </div>

        <div className="filter-group">
          <label>Price Range (Rs.)</label>
          <div className="price-range">
            <input type="number" placeholder="Min" value={filters.minPrice}
              onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })} />
            <span>to</span>
            <input type="number" placeholder="Max" value={filters.maxPrice}
              onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })} />
          </div>
        </div>

        <button className="clear-btn" onClick={() => setFilters({ category: '', city: '', search: '', minPrice: '', maxPrice: '' })}>
          Clear All Filters
        </button>
      </div>

      <div className="services-main">
        <div className="services-header">
          <h2>{filters.category || 'All'} Services {filters.city ? `in ${filters.city}` : ''}</h2>
          <span className="results-count">{services.length} providers found</span>
        </div>

        {loading ? (
          <div className="loading-state">
            {[1,2,3].map(i => <div key={i} className="skeleton-card"></div>)}
          </div>
        ) : services.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🔍</div>
            <h3>No services found</h3>
            <p>Try changing your filters or search terms</p>
          </div>
        ) : (
          <div className="services-list">
            {services.map(service => (
              <Link key={service._id} to={`/services/${service._id}`} className="service-list-card">
                <div className="slc-left">
                  <div className="slc-avatar">{service.provider?.name?.charAt(0) || 'P'}</div>
                </div>
                <div className="slc-body">
                  <div className="slc-top">
                    <div>
                      <div className="slc-title">{service.title}</div>
                      <div className="slc-provider">by {service.provider?.name} • 📍 {service.city}</div>
                    </div>
                    <div className="slc-badge">{service.category}</div>
                  </div>
                  <div className="slc-desc">{service.description}</div>
                  <div className="slc-footer">
                    <div className="slc-rating">★ {service.rating?.toFixed(1) || 'New'} ({service.totalReviews || 0} reviews)</div>
                    <div className="slc-price">Rs. {service.price} <span>/{service.priceType?.replace('_', ' ')}</span></div>
                    <button className="slc-book">Book Now</button>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Services;
